// Dynamic viewport height handling for mobile devices
export const initViewportHeight = () => {
  // Set initial viewport height
  const setVH = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  // Set initial value
  setVH();

  // Update on resize
  window.addEventListener('resize', setVH);
  window.addEventListener('orientationchange', setVH);

  // Handle visual viewport changes (for mobile keyboards)
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', setVH);
  }

  return () => {
    window.removeEventListener('resize', setVH);
    window.removeEventListener('orientationchange', setVH);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', setVH);
    }
  };
};

// Utility to check if device is mobile
export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

// Utility to check if keyboard is likely open
export const isKeyboardOpen = () => {
  if (!window.visualViewport) return false;
  
  const windowHeight = window.innerHeight;
  const viewportHeight = window.visualViewport.height;
  
  // If viewport height is significantly less than window height, keyboard is likely open
  return viewportHeight < windowHeight * 0.8;
};

// Utility to get current viewport height
export const getViewportHeight = () => {
  return window.visualViewport?.height || window.innerHeight;
};
